import styled from "styled-components";

import { flexColumn, rem } from "@styles/Utilities.styled";


export const StyledViewProfileModalContent = styled.div`
  .description {
    span {
      color: var(--clr-primary-400);
      font-weight: 500;
    }
  }

  .reasons {
    ${flexColumn}
    gap: 0.5rem;
    margin-top: 1.5rem;

    .RadioGroupRoot {
      ${flexColumn}
      gap: 0.5rem;
    }

    .RadioGroupItem {
      width: 100%;
      font-size: ${rem(13)};
      padding: 0.75em 0 0.75em 1.5em;
      color: inherit;
      text-align: left;
      border: 1px solid var(--clr-gray-200);
      border-radius: var(--border-radius-3);
      outline: none;

      &:hover,
      &:focus {
        background-color: var(--clr-gray-100);
      }

      &[data-state="checked"] {
        color: var(--clr-white);
        border-color: rgb(0, 0, 0, 0);
        background-color: var(--clr-primary-400);
      }
    }
  }
`;
